<section>
  <h1>{{ title }}</h1>
  <p-tabView [(activeIndex)]="activeTabIndex" (onChange)="onTabChange($event)" styleClass="tabview-wizard" [tabindex]="-1" autofocus>
    <p-tabPanel headerStyleClass="tabpanel-header-wizard" [headerStyle]="{maxWidth:'25%'}" [disabled]="notesSummary.displayAttachmentErrorMessage">
      <ng-template pTemplate="header">
        <span class="round-tabs">
          <i class="fas fa-edit fa-md" aria-hidden="true"></i>
        </span>
        <span class="round-tabs-label">Basic Tracking Data</span>
      </ng-template>
      <ness-tracking #tracking (tdSubmitted)="updateReportData($event)"></ness-tracking>
    </p-tabPanel>
    <p-tabPanel headerStyleClass="tabpanel-header-wizard" [headerStyle]="{maxWidth:'25%'}" [disabled]="tracking.trackingDataForm.invalid || notesSummary.displayAttachmentErrorMessage">
      <ng-template pTemplate="header">
        <span class="round-tabs">
          <i class="fas fa-user fa-md" aria-hidden="true"></i>
        </span>
        <span class="round-tabs-label">Events, NIBIN Leads, &amp; Targets</span>
      </ng-template>
      <ness-events-leads-targets #eventsLeads (eltSubmitted)="updateReportData($event)"></ness-events-leads-targets>
    </p-tabPanel>
    <p-tabPanel headerStyleClass="tabpanel-header-wizard" [headerStyle]="{maxWidth:'25%'}" [disabled]="tracking.trackingDataForm.invalid">
      <ng-template pTemplate="header">
        <span class="round-tabs">
          <i class="fas fa-clipboard-list fa-md" aria-hidden="true"></i>
        </span>
        <span class="round-tabs-label">Summary &amp; Notes</span>
      </ng-template>
      <ness-summary-notes #notesSummary (nsSubmitted)="updateReportData($event)"></ness-summary-notes>
    </p-tabPanel>
    <p-tabPanel headerStyleClass="tabpanel-header-wizard" [headerStyle]="{maxWidth:'25%'}" [disabled]="tracking.trackingDataForm.invalid || notesSummary.displayAttachmentErrorMessage">
      <ng-template pTemplate="header">
        <span class="round-tabs green-tab">
          <i class="fas fa-check fa-md" aria-hidden="true"></i>
        </span>
        <span class="round-tabs-label">Review</span>
      </ng-template>
      <ness-info-report-review #review (linkClicked)="activateTab($event)"
                               [updatedIR]="_updatedIR"
                               [trackingInvalid]="tracking.trackingDataForm.invalid"
                               [eventsLeadsInvalid]="eventsLeads.eventsLeadsTargetsForm.invalid"
                               [notesSummaryInvalid]="notesSummary.summaryNotesForm.invalid"
                               [trackingSubmitted]="_trackingSubmitted"
                               [eventsLeadsSubmitted]="_eventsLeadsSubmitted"
                               [notesSummarySubmitted]="_notesSummarySubmitted">
      </ness-info-report-review>
    </p-tabPanel>
  </p-tabView>
  <div class="d-flex flex-wrap justify-content-center">
    <button *ngIf="activeTabIndex > 0" [disabled]="notesSummary.displayAttachmentErrorMessage" (click)="gotoPrevTab()" type="button" class="btn btn-active btn-fixed-w120 mb-2"><i aria-hidden="true" class="fas fa-angle-left"></i> Previous</button>
    <button *ngIf="activeTabIndex < 3" type="button" [disabled]="tracking.trackingDataForm.invalid  || notesSummary.displayAttachmentErrorMessage" (click)="gotoNextTab()" class="btn btn-active btn-fixed-w120 mb-2">Next <i class="fas fa-angle-right" aria-hidden="true"></i></button>
    <button *ngIf="activeTabIndex == 3" type="button" [disabled]="tracking.trackingDataForm.invalid ||  notesSummary.displayAttachmentErrorMessage || !_reviewReady || clicked" class="btn btn-active btn-fixed-w120 mb-2" (click)="clicked = true; saveInfoReport();">{{ buttonTitle}}</button>
  </div>
</section>
